<ng-template #loading>
  <app-mat-spinner-overlay text="Henter fagområder..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="data; else loading">
  <h1>{{getLabelValue('Title') | striphtml}}</h1>

  <p [innerHTML]="getLabelValue('WelcomeText') | safe: 'html'"></p>

  <h1 [innerHTML]="getLabelValue('TitleAreas') | safe: 'html'"></h1>

  <div class="button-row">

    <div class="button-column introbutton">
      <app-introbutton (click)="navigate('/select/0')" [icon]="'attach_money'"
        [title]="getLabelValue('ButtonBankAndFinance')" [description]="getLabelValue('ButtonBankAndFinanceDescription')"
        [tooltip]="getLabelValue('ButtonBankAndFinanceTooltip')"></app-introbutton>
    </div>

    <div class="button-column introbutton">
      <app-introbutton (click)="navigate('/select/1')" [icon]="'account_balance_wallet'"
        [title]="getLabelValue('ButtonDebtCollection')" [description]="getLabelValue('ButtonDebtCollectionDescription')"
        [tooltip]="getLabelValue('ButtonDebtCollectionTooltip')"></app-introbutton>
    </div>

    <div class="button-column introbutton">
      <app-introbutton (click)="navigate('/select/2')" [icon]="'people'"
        [title]="getLabelValue('ButtonPersonalInsurance')"
        [description]="getLabelValue('ButtonPersonalInsuranceDescription')"
        [tooltip]="getLabelValue('ButtonPersonalInsuranceTooltip')"></app-introbutton>
    </div>

    <div class="button-column introbutton">
      <app-introbutton (click)="navigate('/select/3')" [icon]="'local_fire_department'"
        [title]="getLabelValue('ButtonInsurance')" [description]="getLabelValue('ButtonInsuranceDescription')"
        [tooltip]="getLabelValue('ButtonInsuranceTooltip')">
      </app-introbutton>
    </div>

    <div class="button-column introbutton">
      <app-introbutton (click)="navigate('/select/4')" [icon]="'car_crash'" [title]="getLabelValue('ButtonCollision')"
        [description]="getLabelValue('ButtonCollisionDescription')" [tooltip]="getLabelValue('ButtonCollisionTooltip')">
      </app-introbutton>
    </div>

    <div class="button-column introbutton">
      <app-introbutton (click)="navigate('/select/5')" [icon]="'home'" [title]="getLabelValue('ButtonOwnership')"
        [description]="getLabelValue('ButtonOwnershipDescription')" [tooltip]="getLabelValue('ButtonOwnershipTooltip')">
      </app-introbutton>
    </div>

  </div>

  <div class="flex-column flex-gap-20">

    <span class="click" (click)="toggleMoreInfoText()" [innerHTML]="getLabelValue('MoreInfoHeader') | safe: 'html'"></span>

    <div [innerHtml]="getLabelValue('MoreInfoText') | safe: 'html'" *ngIf="showMoreInfoText"></div>

  </div>


</div>